import Axios from 'axios'
import getTokens from 'utilities/getTokens'
import { POLICY_MASTER } from './reducers'

export const fetchPolicymaster = (campaignId, callback) => {
  const token = getTokens()

  return async (dispatch, getState) => {
    const { policymaster } = getState().toJS()
    console.log('servicesData--------from avction--', policymaster)
    dispatch({ type: POLICY_MASTER.LOADING })

    const res = await Axios({
      url: `/policymaster/campaign/${campaignId}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => {
        if (callback) callback(res)
        dispatch({ type: POLICY_MASTER.FETCHED, payload: res.data })
      })
      .catch((err) => {
        console.log('cathcing at error', err)
        dispatch({ type: POLICY_MASTER.ERROR, payload: 'Not Found' })
        if (callback) callback(err, true)
      })
    return res
  }
}




export const postPolicymaster = (service, callback) => {
  const token = getTokens()

  return async (dispatch,getState) => {
    const { policymaster, policyCampaigns, auth } = getState().toJS()
    dispatch({ type: POLICY_MASTER.LOADING })
    const res = await Axios({
      url:
        Object.keys(policymaster.data).length > 0
          ? `policymaster/${policymaster.data._id}`
          : '/policymaster',
      method: Object.keys(policymaster.data).length > 0 ? 'PUT' : 'POST',
      headers: { Authorization: `Bearer ${token}` },
      // data
      data: {
        user: auth.user._id,
        trackingId: policyCampaigns.openedCampaign.trackingId,
        policyCampaign: policyCampaigns.openedCampaign._id,
        websiteUrl: policyCampaigns.openedCampaign.websiteUrl,
        service,
      },
    })
      .then((res) => {
        if (callback) callback(res)
        dispatch({ type: POLICY_MASTER.POSTED, payload: res.data })
        dispatch({
          type: 'FIRE_TOASTER',
          payload: { type: 'success', message: 'Service Updated' },
        })
      })
      .catch((err) => {
        if (callback) callback(err, true)
        dispatch({ type: POLICY_MASTER.ERROR, payload: err.message })
        dispatch({
          type: 'FIRE_TOASTER',
          payload: { type: 'error', message: 'Some Error Occurred' },
        })
      })
    return res
  }
}


export const getPolicyPdf = async (campaignId, callback) => {
  const token = getTokens()

  const response = await Axios({
    method: 'GET',
    url: `policymaster/generatepdf/${campaignId}?type=pdf`,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      console.log(res)
      if (Object.keys(res.data).includes('error') && res.data.error) {
        callback(res.data.message, true)
      } else {
        window.open(res.data.url, '_blank')
        callback(res, false)
      }
    })
    .catch((err) => {
      console.log('cantch is reunnignasdfads f------------')
      if (callback) callback('Some Error Occured', true)
      console.log(err)
    })
  return response
}


export const getPreviewHTML = (campaignId, callback) => {
  const token = getTokens()

  // return response

  return async (dispatch) => {
    dispatch({ type: POLICY_MASTER.FETCHED_PREVIEW, payload: {} })
    const res = await Axios({
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
      url: `policymaster/generatepdf/${campaignId}?type=preview`,
    }).then((response) => {
      if (callback) callback(response, false)
      dispatch({ type: POLICY_MASTER.FETCHED_PREVIEW, payload: response.data })
    })
  }

  // const response = await Axios({
  //   method: 'GET',
  //   headers: { Authorization: `Bearer ${token}` },
  //   url: `policymaster/generatepdf/${campaignId}?type=preview`,
  // })
  //   .then((res) => {
  //     console.log(res)
  //   })
  //   .catch((err) => {
  //     console.log(err)
  //   })
}